<h1>Favourites</h1>
<p>
  The following is a list of your favourite songs from various artists.<br />
  Click the &nbsp;<mat-icon>queue_music</mat-icon>&nbsp; icon to
  <strong>remove</strong> a song from your list
</p>

<br />

<mat-list>
  <!-- single "favourite" card -->
  <mat-list-item *ngFor="let track of favourites">
    <mat-icon mat-list-icon (click)="removeFromFavourites(track.id)"
      >queue_music</mat-icon
    >
    <div mat-line>
      <mat-card>
        <mat-card-content
          ><strong>{{ track.name }}</strong> -
          {{ convertTime(track.duration_ms) }}<br /><br />
          Artist(s):
          <span
            ><a routerLink="/artist/id">{{ track.artists[0].name }}</a
            >&nbsp;&nbsp;</span
          >

          <br />

          Album: <a routerLink="/album/id"> {{ track.album.name }}</a
          ><br />
          <div *ngIf="track.preview_url">
            <br /><audio controls [src]="track.preview_url"></audio>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-list-item>
  <!-- -->
</mat-list>
